/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { getSubmitData } from '../../store/state/epics/util';
import * as actionType from '../../store/state/actions';
import { logAndCatchError } from '../../utils/rxjs-utils';
import type { Action } from '../../store/state/state-manager';

const DXAPI_ERROR = 'Error occurred during ajax call at createDataObject Epic';

const executeCreateDataObjectRequest = (actionInPayload: Action['payload']) => {
  const { dataPageID, context, headers, containerItemID } = actionInPayload;

  const requestPayloadAPI = {
    data_view_ID: dataPageID
  };

  const { restApi, reqType } = resolveRestApi(actionType.ACTION_CREATE_DATA_OBJECT, requestPayloadAPI);

  const { content: requestPayload } = getSubmitData(containerItemID);
  return from(
    fetch(
      restApi,
      {
        method: reqType,
        headers,
        body: {
          data: requestPayload.content,
          pageInstructions: requestPayload?.pageInstructions
        }
      },
      containerItemID
    )
  ).pipe(
    map((response: any) => {
      return {
        response: response.data,
        actionInPayload
      };
    }),
    logAndCatchError(DXAPI_ERROR, context)
  );
};

export default executeCreateDataObjectRequest;
